import mapKeys from 'lodash/mapKeys';
import camelCase from 'lodash/camelCase';

export default function camelCaseObjectKeys(obj) {
  return mapKeys(obj, (v, k) => camelCase(k));
}
